// extracted by mini-css-extract-plugin
module.exports = {"left_image":"BusApp_left_image__1Fvuz","right_image":"BusApp_right_image__2yTuZ"};